export default "__VITE_PUBLIC_ASSET__a121ca58__"